// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { SasTokenProvider, createSasTokenProvider } from "./auth/tokenProvider.js";
import { isSasTokenProvider } from "./util/typeGuards.js";

export { SasTokenProvider, createSasTokenProvider, isSasTokenProvider };
